import { BrowserModule, Title } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { SenhaComponent } from './pages/senha/senha.component';
import { CadastroComponent } from './pages/cadastro/cadastro.component';
import { ServicoComponent } from './pages/servico/servico.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RouterModule } from '@angular/router';
import { FormWizardModule } from './component/wizard/index';
import { AgendamentoComponent } from './pages/agendamento/agendamento.component';
import { EsqueciComponent } from './pages/esqueci/esqueci.component';
import { HttpClientModule } from '@angular/common/http';
import { UsuarioService } from './services/usuario.service';
import { HttpClientService } from './services/httpClient.service';
import { ConfigurationService } from './services/configuration.service';
import { AuthGuard } from './guard/auth.guard';
import { ServicoService } from './services/servico.service';
import { AgendamentoService } from './services/agendamento.service';
import { PaymentService } from './services/payment.service';
import { FileUploadModule } from 'primeng/fileupload';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { DatePipe } from '@angular/common';
import { AlertService } from './component/Alert/alert.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { Ng2LoadingSpinnerModule, ANIMATION_TYPES } from 'ng2-loading-spinner';
import { TextMaskModule } from 'angular2-text-mask';
import { RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { GoogleAnalyticsService } from "./services/google-analytics.service";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagamentoComponent } from './pages/pagamento/pagamento.component';
import { IbgeService } from './services/ibge.service';
import { AddressFormatPipe } from './pipes/address-format.pipe';
import { DocFormatPipe } from './pipes/doc-format.pipe';
import { CardnumberFormatPipe } from './pipes/cardnumber-format.pipe';
import { LoginEmpresaComponent } from './pages/login-empresa/login-empresa.component';
import { CadastroEmpresaComponent } from './pages/cadastro-empresa/cadastro-empresa.component';
import {CustomSiteService} from "./services/customsite.service";
import { WhatsappButtonComponent } from './whatsapp-button/whatsapp-button.component';

registerLocaleData(localePt, 'pt-BR');

const spinnerOpt = {
  animationType: ANIMATION_TYPES.scalingBars,
  backdropBorderRadius: '8',
  spinnerColor: '#553399',
  backdropColor: '#ededed4d'
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    EsqueciComponent,
    CadastroComponent,
    DashboardComponent,
    ServicoComponent,
    SenhaComponent,
    AgendamentoComponent,
    PagamentoComponent,
    AddressFormatPipe,
    DocFormatPipe,
    CardnumberFormatPipe,
    LoginEmpresaComponent,
    CadastroEmpresaComponent,
    WhatsappButtonComponent,
    WhatsappButtonComponent
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FormWizardModule,
    HttpClientModule,
    FileUploadModule,
    TextMaskModule,
    RecaptchaModule,
    NgbModule,
    Ng2LoadingSpinnerModule.forRoot(spinnerOpt),
    SimpleNotificationsModule.forRoot({
      timeOut: 3000,
      showProgressBar: true,
      clickToClose: false,
      clickIconToClose: false
    })
  ],
  providers: [
    AuthGuard,
    HttpClientService,
    UsuarioService,
    ServicoService,
    AgendamentoService,
    PaymentService,
    IbgeService,
    AlertService,
    GoogleAnalyticsService,
    DatePipe,
    Title,
    CustomSiteService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigurationService) => () => configService.loadConfigurations().toPromise(),
      deps: [ConfigurationService],
      multi: true
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: "pt",
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
